import form from "./form";
import { useSelect2WithoutAjax } from "./tools";

export default () => {
  form("t-large");
  useSelect2WithoutAjax(".js-select2");
};
